import React from "react";
import { SunTextProps } from "../../../models/sun-text.model";

export const SunText: React.FC<SunTextProps> = ({ onAnimationEnd }) => (
	<div className="bonk-text">
		<h1 style={{ animation: "scaleFadeIn 1s ease forwards" }}>BONK</h1>
		<h3
			style={{ animation: "scaleFadeIn 2.5s ease forwards" }}
			onAnimationEnd={onAnimationEnd}
		>
			MORE THAN ORDINARY
		</h3>
	</div>
);
